import { useQuery } from 'react-query';
import { getSubParcel } from 'services/subParcel.service';
import type { SubParcelItem } from 'services/subParcel.service';

interface UseSubParcelParams {
  shipmentUuid: string;
  organizationId: number;
  destinationCarrierId?: number;
  enabled: boolean;
}

interface UseSubParcelResult {
  data: string | null;
  isLoading: boolean;
}

/**
 * Fetches sub-parcel tracking number for Destination Carrier
 *
 * Filters sub-parcels by destination carrier ID to find the correct sub-parcel
 * matching: parent_id = parcel.id AND carrier.id = destination_carrier.id
 */
export const useSubParcel = ({
  shipmentUuid,
  organizationId,
  destinationCarrierId,
  enabled,
}: UseSubParcelParams): UseSubParcelResult => {
  const { data, isLoading } = useQuery<SubParcelItem>(
    ['subParcel', shipmentUuid, organizationId, destinationCarrierId],
    () => getSubParcel({ shipmentUuid, organizationId, destinationCarrierId }),
    {
      enabled,
    },
  );

  return {
    data: data?.trackingNumber,
    isLoading,
  };
};
